import React, { useReducer } from 'react';

const INITIAL_MODAL_STATE = {
  message: '',
  show: false,
  handleClose: () => null,
  handleConfirm: () => null,
};

const actions = {
  SHOW_MODAL: 'SHOW_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.CLOSE_MODAL:
      return {
        message: '',
        show: false,
      };
    case actions.SHOW_MODAL:
      return {
        message: action.modalState.message,
        handleClose: action.modalState.handleClose,
        handleConfirm: action.modalState.handleConfirm,
        show: true,
      };
    default:
      return state;
  }
};

export const ConfirmationModalContext = React.createContext();

export const ConfirmationModalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_MODAL_STATE);
  const value = {
    confirmationModal: {
      message: state.message,
      show: state.show,
      handleClose: state.handleClose,
      handleConfirm: state.handleConfirm,
    },
    showModal: ({ message, handleConfirm, handleClose }) => {
      dispatch({
        type: actions.SHOW_MODAL,
        modalState: { message, handleConfirm, handleClose },
      });
    },
    hideModal: () => {
      dispatch({ type: actions.CLOSE_MODAL });
    },
  };
  return (
    <ConfirmationModalContext.Provider value={value}>{children}</ConfirmationModalContext.Provider>
  );
};

export const useConfirmationModal = () => {
  return React.useContext(ConfirmationModalContext);
};
